export default __webpack_public_path__ + "static/media/INKLING.2c6182ef.svg";